import { FormRow, FormRowSelect, Alert } from '../../components';
import { useGlobalContext } from '../../context/GlobalContext';

const AddLesson = () => {
  const {
    isLoading,
    isEditing,
    showAlert,
    displayAlert,
    day,
    date,
    duration,
    age,
    locationName,
    locationAddress,
    lessonType,
    lessonTypeOptions,
    handleChange,
    clearValues,
    createLesson,
    editLesson,
  } = useGlobalContext();

  const handleSubmit = (e) => {
    e.preventDefault();

    if (
      !day ||
      !date ||
      !duration ||
      !age ||
      !locationName ||
      !locationAddress ||
      !lessonType
    ) {
      displayAlert();
      return;
    }
    if (isEditing) {
      editLesson();
      return;
    }
    createLesson();
  };
  const handleLessonInput = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    handleChange({ name, value });
  };

  return (
    <form className='form'>
      <h3>{isEditing ? 'edit lesson' : 'add lesson'}</h3>
      {showAlert && <Alert />}
      <div className='form-center'>
        {/* day */}
        <FormRow
          type='text'
          name='day'
          value={day}
          handleChange={handleLessonInput}
        />
        {/* date */}
        <FormRow
          type='text'
          name='date'
          value={date}
          handleChange={handleLessonInput}
        />
        {/* duration */}
        <FormRow
          type='text'
          name='duration'
          value={duration}
          handleChange={handleLessonInput}
        />
        {/* age */}
        <FormRow
          type='text'
          name='age'
          value={age}
          handleChange={handleLessonInput}
        />
        {/* location name */}
        <FormRow
          type='text'
          labelText='lesson location name'
          name='lessonLocationName'
          value={locationName}
          handleChange={handleLessonInput}
        />
        {/* location address */}
        <FormRow
          type='text'
          labelText='lesson location address'
          name='lessonLocationAddress'
          value={locationAddress}
          handleChange={handleLessonInput}
        />
        {/* lesson type */}
        <FormRowSelect
          name='lessonType'
          labelText='lesson type'
          value={lessonType}
          handleChange={handleLessonInput}
          list={lessonTypeOptions}
        />
        {/* btn container */}
        <div className='btn-container'>
          <button
            type='submit'
            className='btn btn-block submit-btn'
            onClick={handleSubmit}
            disabled={isLoading}
          >
            submit
          </button>
          <button
            className='btn btn-block clear-btn'
            onClick={(e) => {
              e.preventDefault();
              clearValues();
            }}
          >
            clear
          </button>
        </div>
      </div>
    </form>
  );
};

export default AddLesson;
